import React from "react";

import Code from "./content/code";

const CodePage = () => {
	return <Code/>;
};

export default CodePage;
